import { View } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';
import { ReactNode } from 'react';
import styles from './styles';

type Props = {
  children?: ReactNode | ReactNode[];
  one?: boolean;
  column?: boolean;
  centerH?: boolean;
  centerV?: boolean;
  spaced?: boolean;
  spacedLarge?: boolean;
  noWrap?: boolean; // To avoid page break of components
  style?: Style;
};

function ReportFlex({
  children,
  one,
  column,
  centerH,
  centerV,
  spaced,
  spacedLarge,
  noWrap,
  style
}: Props) {
  const styleList: Style[] = [styles.flex];

  const styleConditions: { [key: string]: boolean | undefined } = {
    flexOne: one,
    flexColumn: column,
    flexCenterH: centerH,
    flexCenterV: centerV,
    spaced,
    spacedLarge
  };
  Object.keys(styleConditions).forEach(key => {
    if (styleConditions[key]) {
      styleList.push(styles[key as keyof typeof styles]);
    }
  });
  if (style) {
    styleList.push(style);
  }
  return (
    <View wrap={!noWrap} style={styleList}>
      {children}
    </View>
  );
}

export default ReportFlex;
